import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class RaceService {
  constructor(private http: HttpClient, private authService: AuthService) {}
  public async getBalance(): Promise<Observable<any>> {
    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${await this.authService.getToken()}`
    );
    return this.http.get(`${environment.API_BASE}api/corrida/saldo`, options);
  }
  public async getRaceInfo(filaId, motoristaId): Promise<Observable<any>> {
    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${await this.authService.getToken()}`
    );
    return this.http.get(`${environment.API_BASE}api/fila/informacoes?filaId=${filaId}&motoristaId${motoristaId}`, options);
  }
}
